import { render, staticRenderFns } from "./MedicationFluidSelector.vue?vue&type=template&id=2f12fb52&scoped=true&"
import script from "./MedicationFluidSelector.vue?vue&type=script&lang=js&"
export * from "./MedicationFluidSelector.vue?vue&type=script&lang=js&"
import style0 from "./MedicationFluidSelector.vue?vue&type=style&index=0&id=2f12fb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f12fb52",
  null
  
)

export default component.exports